<div class="row mt-5">
  <div class="mx-auto">    
    <div class="access-denied-card">
      <div class="card-header">
        <div class="access-icon">
          <i class="material-icons">lock_outline</i>
        </div>
        <h1>Access Restricted</h1>
        <p>We're sorry, but you don't have permission to view this page</p>
      </div>

      <div class="card-content">
        <div class="friendly-message">
          The page you're trying to access requires special permissions or may have been moved.
        </div>

        <!--<div class="suggestions">
          <h3>
            <i class="material-icons" style="color: #1976d2;">lightbulb_outline</i>
            Here's what you can try:
          </h3>
          <ul class="suggestion-list">
            <li class="suggestion-item">
              <div class="suggestion-icon">
                <i class="material-icons">person</i>
              </div>
              <span>Contact your administrator to request access to this page</span>
            </li>
            <li class="suggestion-item">
              <div class="suggestion-icon">
                <i class="material-icons">refresh</i>
              </div>
              <span>Try refreshing the page - sometimes it's just a temporary glitch</span>
            </li>
            <li class="suggestion-item">
              <div class="suggestion-icon">
                <i class="material-icons">home</i>
              </div>
              <span>Go back to the dashboard and navigate from there</span>
            </li>
            <li class="suggestion-item">
              <div class="suggestion-icon">
                <i class="material-icons">help_outline</i>
              </div>
              <span>Check if you have the correct permissions for this feature</span>
            </li>
          </ul>
        </div>-->

        <div class="action-buttons">
          <a class="primary-button" [routerLink]="['/dashboard']">
            <i class="material-icons" style="font-size: 16px; margin-right: 8px;">home</i>
            Go to Dashboard
          </a>
          <!--<a href="#" class="secondary-button">
            <i class="material-icons" style="font-size: 16px;">support_agent</i>
            Contact Support
          </a>-->
        </div>
      </div>
    </div>
  </div>
</div>



